import type {
  AttendancePolicyV2Allowance,
  Final14DayProtection,
  ProtectedPeriodOverride,
} from '@airreading/common/data';

export function protectedPeriodOverrideFromForm(formData: {
  protectedPeriodOverrideReason?: string | null;
}): ProtectedPeriodOverride | undefined {
  const reason = formData.protectedPeriodOverrideReason?.trim();
  if (!reason) {
    return undefined;
  }
  return { reason };
}

export function anyStudentGroupNeedsProtectedPeriodOverride(
  studentGroups: Array<{
    attendancePolicyV2?: AttendancePolicyV2Allowance | null;
    final14DayProtection?: Final14DayProtection;
  }>,
): boolean {
  return studentGroups.some(
    (group) => (group.final14DayProtection ?? group.attendancePolicyV2?.final14DayProtection)?.isProtected,
  );
}
